import { render, staticRenderFns } from "./TestimonialCarousel.vue?vue&type=template&id=c5dca4b8&scoped=true&"
import script from "./TestimonialCarousel.vue?vue&type=script&lang=js&"
export * from "./TestimonialCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5dca4b8",
  null
  
)

export default component.exports